import { Login } from "./login";

export class User extends Login {
  userId: number = 0;
  firstName: string = "";
  lastName: string = "";
  verificationCode: string = "";
  address: string = "";
  city: string = "";
  zip: string = "";
  mobileNumber: number;
  instagramId: string = "";
  faceBookId: string = "";
  tikTokId: string = "";
  profilePicture: any;
  profilePictureUrl: string = null;
  Lat: number = 0.00;
  Lng: number = 0.00;
  isMembershipVendor: boolean;
  allowArticleCreation?: boolean;
  allowPreRegistration?: boolean;
}
